import React, { Component } from 'react'
import { Loading } from '@fielded/shared-ui'
import Profile from '../components/Profile'
import { withAuth } from '../../../common/AuthenticationProvider'
import { documentInfo, driverDocumentInfo, hasUserContract } from '../../settings/common/utils'
import withConfig from '../../../van-shared/hoc/withConfig'
import { withApi } from '../../../common/ApiProvider'
import { userIsAuthorised } from '../../../van-shared/utils/auth'

class ProfileContainer extends Component {
  state = {
    loading: true,
    isRetailer: false,
    loaded: false,
    success: null,
    error: null,
    verificationLoading: false
  }

  async componentDidMount () {
    const { api, user } = this.props
    const locationId = user.location.id
    const isRetailer = userIsAuthorised(user, 'feature:userRole:pharmacyUser')
    // Note: this is what disables the contracts for the NG drivers:
    const driverWithContracts = hasUserContract(user)
    let locationDisplayName

    try {
      const location = await api.location.get(locationId)
      locationDisplayName = location.fullName
    } catch (error) {
      locationDisplayName = user.location.id
    }

    let pendingContracts = 0

    if (isRetailer) {
      // pending contracts need for shelf life for showing bubble in contracts title
      const { pending } = await documentInfo(api, locationId)
      pendingContracts = pending
    } else if (driverWithContracts) {
      // pending contracts need for shelf life for showing bubble in contracts title
      const { pending } = await driverDocumentInfo(api, user._id)
      pendingContracts = pending
    }

    this.setState({
      loading: false,
      pendingContracts,
      locationDisplayName,
      isRetailer,
      driverWithContracts
    })
  }

  saveData = async (fields) => {
    const { api } = this.props
    this.setState({ saving: true })

    try {
      const userData = {
        fullName: fields.displayName
        // Email and phone are only updated through verification process
      }
      await api.currentUser.update(userData)
      this.props.updateUser()
      this.setState({ success: 'Profile successfully updated', error: false, saving: false })
    } catch (e) {
      this.setState({ error: `Can't update profile`, success: false, saving: false })
    }
  }

  sendVerificationCode = async (method, contactInfo) => {
    const { api } = this.props
    this.setState({ verificationLoading: true, success: null, error: null })
    try {
      const data = method === 'email'
        ? { method, email: contactInfo }
        : { method, phoneNumber: contactInfo }

      await api.currentUser.sendVerificationCode(data)
      this.setState({
        success: `Verification code sent to your ${method}`,
        error: null,
        verificationLoading: false
      })
    } catch (error) {
      this.setState({
        error: error.message || `Failed to send verification code to ${method}`,
        success: null,
        verificationLoading: false
      })
      throw error
    }
  }

  verifyCode = async (method, code, contactInfo) => {
    const { api } = this.props
    this.setState({ verificationLoading: true })
    try {
      const data = method === 'email'
        ? { method, code: code, email: contactInfo }
        : { method, code: code, phoneNumber: contactInfo }

      await api.currentUser.verifyCode(data)
      this.props.updateUser()
      this.setState({
        success: `${method === 'email' ? 'Email' : 'Phone'} verified successfully!`,
        error: null,
        verificationLoading: false
      })
    } catch (error) {
      this.setState({
        error: error.message || 'Invalid verification code',
        success: null,
        verificationLoading: false
      })
      throw error
    }
  }

  render () {
    const {
      loading,
      locationDisplayName,
      isRetailer,
      success,
      error,
      saving,
      verificationLoading
    } = this.state
    const { user, config, history } = this.props

    if (loading) {
      return <Loading />
    }

    return <Profile
      locationDisplayName={locationDisplayName}
      isRetailer={isRetailer}
      user={user}
      success={success}
      error={error}
      saving={saving}
      saveData={this.saveData}
      verificationLoading={verificationLoading}
      sendVerificationCode={this.sendVerificationCode}
      verifyCode={this.verifyCode}
      config={config}
      history={history}
    />
  }
}

export default withAuth('user', 'updateUser')(withConfig(withApi(ProfileContainer)))
